import './App.css';
import React, { useState,useEffect, useRef } from "react";
import Slider from "react-slick";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ott01 from './img/myflix01.webp';
import ott02 from './img/myflix02.webp';
import ott03 from './img/myflix03.webp';
import portflio1 from './img/portfolio01.webp';
import ytb1 from './img/ytb01.webp';
import ytb2 from './img/ytb02.webp';
import ytb3 from './img/ytb03.webp';

import chatlive01 from './img/chatlive01.webp';
import chatlive02 from './img/chatlive02.webp';
import chatlive03 from './img/chatlive03.webp';

import portflio3 from './img/portfolio03.webp';
import moop1 from './img/moop1.png';
import moop2 from './img/moop2.png';
import moop3 from './img/moop3.png';
import openquiz1 from './img/openquiz1.webp';
import openquiz2 from './img/openquiz2.webp';
import openquiz3 from './img/openquiz3.webp';
import weaterLive1 from './img/weather1.webp';
import weaterLive2 from './img/weather2.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const tagSvgs = {
  html: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 9L5 12L8 15" />
      <path d="M16 9L19 12L16 15" />
      <path d="M14 8L10 16" />
    </svg>
  ),

css: (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* 바깥 여백 + 안쪽 여백(패딩) 느낌 */}
    <rect
      x="2.5"
      y="5.5"
      width="19"
      height="13"
      rx="3.5"
    />
    <text
      x="12"
      y="12.2"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="8.4"
      fontWeight="900"
      letterSpacing="1.3"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.35"
      paintOrder="stroke"
      fontFamily="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
    >
      CSS
    </text>
  </svg>
),

// #JavaScript (JS badge: square + "JS")
javascript: (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="4" width="16" height="16" rx="3" />
    {/* J */}
    <path d="M10.5 8.5v7c0 1.1-.9 2-2 2" />
    {/* S */}
    <path d="M15.8 9.2c-.5-.5-1.1-.7-1.8-.7-1 0-1.8.6-1.8 1.5 0 .8.6 1.2 1.6 1.5l.5.1c1.2.3 2 .9 2 2 0 1.3-1.1 2.2-2.7 2.2-1 0-1.9-.3-2.5-1" />
  </svg>
),

  typescript: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M8 9h8" />
      <path d="M12 9v10" />
    </svg>
  ),

  react: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
      <ellipse cx="12" cy="12" rx="9" ry="4" />
      <ellipse cx="12" cy="12" rx="9" ry="4" transform="rotate(60 12 12)" />
      <ellipse cx="12" cy="12" rx="9" ry="4" transform="rotate(120 12 12)" />
    </svg>
  ),

  next: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9 16V8l6 8V8" />
    </svg>
  ),

  vue: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 6l8 14L20 6" />
      <path d="M7 6l5 9 5-9" />
    </svg>
  ),

  nuxt: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3.5 19h17" />
      <path d="M5.5 19L11 9l4 7 2-3 3.5 6" />
    </svg>
  ),

  sql: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx="12" cy="6.5" rx="7.5" ry="3.5" />
      <path d="M4.5 6.5V17.5C4.5 19.4 7.9 21 12 21C16.1 21 19.5 19.4 19.5 17.5V6.5" />
      <path d="M4.5 12c0 1.9 3.4 3.5 7.5 3.5S19.5 13.9 19.5 12" />
    </svg>
  ),
};

function App() {
  const mountRef = useRef(null);

  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [projectList, setProjectList] = useState([
    // {
    //   no: 1,
    //   pjtName: "김정민 포트폴리오",
    //   exp: "React 기반으로 제작한 인터랙션 중심 개인 포트폴리오 웹사이트",
    //   url: "https://www.kjms.shop/",
    //   popupText: "React를 기반으로 제작한 개인 포트폴리오 웹사이트입니다. 프로젝트 데이터를 배열로 관리하여 동적으로 렌더링하고, 모달 팝업과 이미지 슬라이더를 구현해 상세 정보를 제공합니다. AOS를 활용한 스크롤 애니메이션을 적용해 사용자 흐름을 고려했으며, 재사용 가능한 구조로 설계해 유지보수와 확장이 가능하도록 구성했습니다.",
    //   subTitle: "React 기반 개인 포트폴리오 웹사이트",
    //   images: [portflio1, portflio2, portflio3],
    //   tags: [2, 5]
    // },

    {
      no: 2,
      pjtName: "TubeInsight",
      exp: "YouTube 채널·영상 데이터를 분석하고 탐색할 수 있는 유튜브 인사이트 웹 애플리케이션",
      url: "https://tube-insight-smoky.vercel.app/",
      popupText:
        "YouTube Data API를 활용해 채널 검색, 채널 정보 분석, 영상 목록 조회 기능을 구현한 웹 서비스입니다. 채널 구독자 수·총 조회수·영상 수 등 핵심 지표를 시각적으로 확인할 수 있으며, 검색 기반으로 다양한 유튜브 채널과 콘텐츠를 탐색할 수 있습니다. Next.js App Router, React 19, TypeScript, Tailwind CSS 기반으로 개발했으며 API 캐싱을 적용해 YouTube quota 사용을 최적화했습니다.",
      subTitle:
        "YouTube 채널·영상 데이터를 검색하고 핵심 지표를 확인할 수 있는 유튜브 분석 서비스",
      images: [ytb1, ytb2, ytb3],
      tags: [1, 3],
    },
    {
      no: 3,
      pjtName: "ChatLive",
      exp: "Socket.io 기반으로 구현한 실시간 채팅 웹 애플리케이션",
      url: "https://chat-live-beta.vercel.app/",
      popupText: "Socket.io를 활용해 실시간 채팅 기능을 구현했으며, 일반 메시지와 스페셜 메시지(텍스트 폭죽 애니메이션)를 지원합니다. React·Next.js App Router·TypeScript 기반으로 개발했고, 실시간 메시지 수신·자동 스크롤 제어·Shift+Enter 입력 처리·스페셜 메시지 애니메이션 표시 등을 구현한 실시간 채팅 서비스입니다.",
      subTitle: "Socket.io 기반 실시간 채팅 서비스",
      images: [chatlive01, chatlive02, chatlive03],
      tags: [1, 4]
    },

    
    { no: 4, pjtName: "Open Quiz", exp: "카테고리별 퀴즈를 만들고 풀 수 있는 웹 애플리케이션", url: "https://open-quiz-rho.vercel.app/", popupText: "Open Quiz는 Next.js App Router와 PostgreSQL(Render), NextAuth(카카오 로그인)로 구현한 퀴즈 서비스입니다. 태그별 퀴즈 목록·퀴즈 상세 및 풀기·제목·부제목·설명·썸네일·문항 이미지를 넣은 퀴즈 만들기·결과 저장 기능을 제공하며, 이미지는 Vercel Blob에 저장합니다.", subTitle: '퀴즈 제작·풀기 웹 애플리케이션', images: [openquiz1, openquiz2, openquiz3], tags: [1, 3] },
    { no: 5, pjtName: "MYFLIX", exp: "Netflix UI/UX를 참고해 구현한 영화·TV 콘텐츠 탐색 웹 애플리케이션", url: "https://myflix-sandy.vercel.app", popupText: "TMDB API를 연동해 인기 영화 목록·랜덤 히어로 배너·무한 스크롤·키워드 검색·장르별 필터·localStorage 기반 좋아요·영화 상세 모달을 구현했고, Next.js App Router·React 19·TypeScript·Tailwind CSS로 개발한 영화 정보 웹 서비스입니다. (영상 재생 기능은 지원하지 않습니다.)", subTitle: 'Netflix UI/UX를 참고해 구현한 영화·TV 콘텐츠 탐색 웹 애플리케이션', images: [ott01, ott02, ott03], tags: [1, 3] },
    
    { no: 6, pjtName: "Weather Live", exp: "날씨를 점수로 번역하는 대시보드", url: "https://weather-live-five.vercel.app/", popupText: "위치 기반 날씨를 불러오고, 기온·체감·습도·풍속·강수 여부를 종합해 ‘외출 점수’를 계산해주는 날씨 대시보드입니다. 낮/밤과 날씨 상태에 따라 배경(구름·도시·별·비)이 자동으로 바뀌어 직관적으로 오늘 컨디션을 확인할 수 있습니다.", subTitle: '날씨를 점수로 번역하는 대시보드', images: [weaterLive1, weaterLive2], tags: [1,3] },
  ]);
  // const [toyProjectList, setToyProjectList] = useState([
  //   { no: 1, pjtName: "LuckyDefense", exp: "당신의 운을 시험하세요.", url: "http://www.kjms.shop/luckyDefense/", popupText: "Lucky Defense는 3가지의 간단한 선택지의 미니게임입니다. 각각 10%, 60%, 100% 확률로 확률에 비례하게 무기를 강화할 수 있습니다. Lucky Defense는 React와 Axios외에 다른 라이브러리없이 Node.js로 구축된 백엔드 서버와 랭킹을 확인하고, 등록할 수 있습니다.", subTitle: '3가지 선택의 간단한 미니게임', images: [ld1, ld2, ld3] },
  //   // { no: 2, pjtName: "QuizForum", exp: "여러가지 어려운 퀴즈를 풀어보세요.", url: "http://www.kjms.shop/luckyDefense/", popupText: "Lucky Defense는 3가지의 간단한 선택지의 미니게임입니다. 각각 10%, 60%, 100% 확률로 확률에 비례하게 무기를 강화할 수 있습니다. Lucky Defense는 React와 Axios외에 다른 라이브러리없이 Node.js로 구축된 백엔드 서버와 랭킹을 확인하고, 등록할 수 있습니다.", subTitle: '3가지 선택의 간단한 미니게임', images: [ld1, ld2, ld3] },
  // ]);

  const tags = [
    {
      id: 1,
      name: 'next',
      svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        <path d="M9 16V8L16 16V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
,
    },
    {
      id: 2,
      name: 'react',
      svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="2" fill="currentColor"/>
        <ellipse cx="12" cy="12" rx="9" ry="4" stroke="currentColor" strokeWidth="1.5"/>
        <ellipse cx="12" cy="12" rx="9" ry="4" stroke="currentColor" strokeWidth="1.5" transform="rotate(60 12 12)"/>
        <ellipse cx="12" cy="12" rx="9" ry="4" stroke="currentColor" strokeWidth="1.5" transform="rotate(120 12 12)"/>
      </svg>

    },
    {
      id: 3,
      name: 'vercel',
      svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L2 21H22L12 3Z"/>
      </svg>

    },
    {
      id: 4,
      name: 'three.js',
      svg: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="12 3 20 8 20 16 12 21 4 16 4 8"
          stroke="currentColor"
          strokeWidth="1.8"
          fill="none"
          strokeLinejoin="round"/>
        
        <line x1="12" y1="3" x2="12" y2="21"
          stroke="currentColor"
          strokeWidth="1.8"/>
        
        <line x1="4" y1="8" x2="20" y2="16"
          stroke="currentColor"
          strokeWidth="1.8"/>
        
        <line x1="20" y1="8" x2="4" y2="16"
          stroke="currentColor"
          strokeWidth="1.8"/>
      </svg>
    },
    {
      id: 5,
      name: 'github',
      svg: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M12 2C6.477 2 2 6.596 2 12.253c0 4.521 2.865 8.353 6.839 9.706.5.096.682-.223.682-.497 0-.244-.009-.891-.014-1.748-2.782.62-3.369-1.372-3.369-1.372-.454-1.183-1.109-1.498-1.109-1.498-.907-.639.069-.626.069-.626 1.003.073 1.531 1.058 1.531 1.058.892 1.566 2.341 1.114 2.91.852.092-.667.349-1.114.635-1.37-2.221-.259-4.555-1.141-4.555-5.077 0-1.122.39-2.04 1.029-2.758-.103-.26-.446-1.301.098-2.713 0 0 .84-.276 2.75 1.053A9.3 9.3 0 0 1 12 6.844c.85.004 1.705.118 2.503.346 1.909-1.329 2.748-1.053 2.748-1.053.546 1.412.203 2.453.1 2.713.64.718 1.028 1.636 1.028 2.758 0 3.946-2.338 4.815-4.566 5.069.359.317.679.944.679 1.903 0 1.374-.012 2.48-.012 2.818 0 .276.18.598.688.496C19.138 20.602 22 16.772 22 12.253 22 6.596 17.523 2 12 2Z"
            fill="currentColor"
          />
        </svg>
      ),
    }
  ]

  const popupShow = (project) => {
    setPopupData({
      pjtName: project.pjtName,
      subTitle: project.subTitle,
      popupText: project.popupText,
      url: project.url,
      images: project.images,
    });
    setShowPopup(true);
    document.body.classList.add('no-scroll');
  };

  const popupHide = () => {
    setShowPopup(false);
    setPopupData({});
    document.body.classList.remove('no-scroll');
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  function getBrowserId() {
    let id = localStorage.getItem("browser_id");

    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem("browser_id", id);
    }

    return id;
  }

  useEffect(() => {
    AOS.init({
      duration: 500, // 애니메이션 지속 시간 (밀리초)
      easing: 'ease-in-out', // 애니메이션 스타일
      once: true, // 스크롤 후 다시 나타나지 않도록 설정
    });

    const id = getBrowserId();

    const form = {
      id: id
    }

    fetch("https://open-quiz-rho.vercel.app/api/searchAnalytics/research",{
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(form)
    })
  }, []);
  return (
    <div className="App">
      <section className="sec_01">
        <div className="container h100">
          <div className="center_box">
            <div className="graphic_wrap">
              <h2 className="mt_minus20">
                <p>안녕하세요</p>
                <span className='upAnimate an1'>프론트엔드</span> <span className='upAnimate an2'>개발자</span> <p className="bold upAnimate an3">김정민입니다.</p>
              </h2>
              <div className="sub_text">
                창의적인 해결책을 찾아 끊임없이 도전하며,<br />
                책임감을 갖고 일하는 개발자입니다.
              </div>
            </div>
          </div>
          <div className="about_arrow">
            About me
          </div>
        </div>
      </section>
      <section className="sec_02">
        <div className="container">
          <div className="introduce_wrap">
            <h2 data-aos="fade-up">What About <span className="bold">Me</span></h2>
            
          </div>
          <div className="skills_wrap">
            <h2 className="mt40" data-aos="fade-up">
              Skills
            </h2>
            <ul className="skill_list" data-aos="fade-up" data-aos-delay="200">
              <li>
                #html
                {tagSvgs.html}
              </li>
              <li>
                #css
                {tagSvgs.css}
              </li>
              <li>
                #JavaScript
                {tagSvgs.javascript}
              </li>
              <li>
                #TypeScript
                {tagSvgs.typescript}
              </li>
              <li>
                #React
                {tagSvgs.react}
              </li>
              <li>
                #Next
                {tagSvgs.next}
              </li>
              <li>
                #Vue
                {tagSvgs.vue}
              </li>
              <li>
                #Nuxt
                {tagSvgs.nuxt}
              </li>
              <li>
                #Sql(이론이해)
                {tagSvgs.sql}
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="sec_03">
        <div className="project_wrap">
          <div className="container">
            <h2 data-aos="fade-up">
              Personal Projects
            </h2>
          </div>
          <div className='project-inner'>
            <div className='container'>
              <ul className="prject_list">
                {projectList.map((project) => (
                  <li key={project.no} onClick={() => popupShow(project)} data-aos="fade-up" data-aos-delay="200">
                    <img src={project.images[0]} alt={project.pjtName} />
                    {/* {JSON.stringify(project)} */}
                    {/* <div className='number'>
                      0{project.no}
                    </div>
                    <h3>{project.pjtName}</h3>
                    <p>{project.exp}</p>
                    <div className='seeMore'>
                      +
                    </div> */}
                    <div className='exp'>
                      <div className='title'>
                        {project.pjtName}
                      </div>

                      <div className='tags'>
                        {
                          project.tags.map((item, index) => {
                            const tagData = tags.find(tag => tag.id === item)

                            return (
                              <div className="tag" key={index}>
                                {tagData?.svg}
                                <div className='text'>
                                  {tagData?.name}
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>

                  </li>
                ))}
              </ul>
            </div>

            
          </div>
        </div>
      </section>
      <section className="sec_04">
        <div className="container">
          <p className="contact" data-aos="fade-up">
            <h2 className='contact_title'>
                Contact
            </h2>
          </p>
          <div className='contact-wrap' data-aos="fade-up" data-aos-delay="200">
            <div className="contact-item"><FontAwesomeIcon icon={faUser} /> 김정민</div>
            <div className="contact-item"><FontAwesomeIcon icon={faPhone} /> 010-8520-5542</div>
            <div className="contact-item"><FontAwesomeIcon icon={faEnvelope} /> kjm980810@gmail.com</div>
            <div className="contact-item"><FontAwesomeIcon icon={faGlobe} /> https://www.kjms.shop</div>
          </div>

        </div>
      </section>
      <section className="sec_05">
        <div className="container">
          <p className="end_text" data-aos="fade-up">
            Thank For Watch !
          </p>
        </div>
      </section>
      {showPopup && (
        <div className="popup">
          <div className="inner">
            <div className='scroll'>
              <div className="title">
                {popupData.pjtName}
                <div className='popupClose' onClick={popupHide}>
                  <FontAwesomeIcon icon={faTimes} size="2x" />
                </div>
              </div>
              <div className='subTitle'>
                {popupData.subTitle}
              </div>
              
              <div className="text">
                {popupData.popupText}
              </div>
              <div className="img">
                {popupData.images.length > 0 ? (
                  <Slider {...sliderSettings}>
                    {popupData.images.map((image, index) => (
                      <div key={index}>
                        <img src={image} alt={`slide-${index}`} />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <p>이미지가 없습니다.</p>
                )}
              </div>
              <div className="button Link" onClick={() => window.open(popupData.url, "_blank")}>
                Link
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
